import { PinCode, PinCodeRendering } from '@frontend/pin-code/types';
import React from 'react';
import Barcode from 'react-barcode';
import QRCode from 'react-qr-code';

import usePinCodeView from './pin-code-view.controller';

const ID = 'pin-code-view';
export interface PinCodeViewProps {
    entityId?: string;
    entityType?: string;
    pinCode?: PinCode;
    codeOverwrite?: string;
    renderingOverwrite?: PinCodeRendering;
    className?: string;
}

export const PinCodeView = (props: PinCodeViewProps) => {
    const viewProps = usePinCodeView(props);

    if (viewProps.isLoading) {
        return <div>Loading...</div>;
    }
    if (!viewProps.code) {
        return <div>No PIN-code available</div>;
    }
    switch (viewProps.rendering) {
        case PinCodeRendering.TEXT:
            return (
                <p
                    id={ID}
                    className={props.className}>
                    {viewProps.code}
                </p>
            );
        case PinCodeRendering.BARCODE_128:
            return (
                <Barcode
                    id={ID}
                    className={props.className}
                    value={viewProps.code}
                    format='CODE128'
                />
            );
        case PinCodeRendering.QR_CODE:
            return (
                <QRCode
                    id={ID}
                    className={props.className}
                    value={viewProps.code}
                />
            );
        case PinCodeRendering.QR_CODE_AND_TEXT:
        default:
            return (
                <div
                    className={props.className}
                    id={ID}>
                    <p className='text-foreground-default w-full text-center text-3xl font-semibold tracking-widest'>{viewProps.code}</p>
                    <QRCode
                        className='w-full text-center'
                        value={viewProps.code}
                    />
                </div>
            );
    }
};

export default PinCodeView;
